import { StyledStatelessComponent } from 'create-emotion-styled/types/react';
import React from 'react';
import styled from '@tanium/react-emotion-9';
import { Link } from '@tanium/react-link';

export const UnstyledLink: StyledStatelessComponent<
  React.ComponentPropsWithoutRef<typeof Link>,
  Record<string, unknown>,
  Record<string, unknown>
> = styled(Link)({
  /* bootstrap override */
  '&&': {
    color: 'inherit',
    textDecoration: 'none',
  },
});
